import { Engineering, Group } from '@mui/icons-material';
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BreadcrumbTrail } from '../crumbs/BreadcrumbTrail';

interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
  isMobile: boolean;
}

export const MenuDrawer: React.FC<MobileDrawerProps> = ({
  open,
  onClose,
  isMobile,
}) => {
  const location = useLocation();

  const menuItems = [
    { text: 'Departments', icon: <Engineering />, path: '/departments' },
    { text: 'Users', icon: <Group />, path: '/users' },
  ];

  return (
    <Drawer
      anchor='left'
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: 280,
          boxSizing: 'border-box',
          backgroundColor: 'background.paper',
          backgroundImage: 'none',
        },
      }}
    >
      <Box
        sx={{
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <img src='/img/csi-logo.png' alt='CSI Logo' style={{ height: 32 }} />
        <Typography
          variant='h6'
          sx={{ fontWeight: 700, color: 'primary.main' }}
        >
          CSI
        </Typography>
      </Box>

      <Divider />

      {/* departments and users navigation */}
      <Box sx={{ px: 2, pb: 1, pt: 8 }}>
        <Typography variant='caption' color='text.secondary'>
          ADMIN
        </Typography>
      </Box>
      <List sx={{ pt: 2 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={onClose}
              sx={{
                textDecoration: 'none',
                color: 'inherit',
                mx: 1,
                borderRadius: 2,
                transition: 'all 0.2s ease',
                '&.Mui-selected': {
                  backgroundColor: 'action.selected',
                  color: 'secondary.main',
                  '& .MuiListItemIcon-root': {
                    color: 'secondary.main',
                  },
                  '&:hover': {
                    backgroundColor: 'action.selected',
                  },
                },
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: 'secondary.main' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  fontWeight: location.pathname === item.path ? 600 : 400,
                  fontSize: '0.95rem',
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* breadcrumbs for mobile */}
      {isMobile && (
        <>
          <Divider sx={{ my: 1 }} />
          <BreadcrumbTrail mobile />
        </>
      )}
    </Drawer>
  );
};
